export const ADD_PIECE_JOINTE = 'ADD_PIECE_JOINTE';
export const REMOVE_PIECE_JOINTE = 'REMOVE_PIECE_JOINTE';
export const SET_CONFIGURATION = 'SET_CONFIGURATION';
export const SET_ELEMENT_ID = 'SET_ELEMENT_ID';
export const SET_LISTE_PIECE_JOINTE = 'SET_LISTE_PIECE_JOINTE';
export const SET_LISTE_TYPE_PIECE_JOINTE = 'SET_LISTE_TYPE_PIECE_JOINTE';
export const SET_LOGO = 'SET_LOGO';
export const SET_MODULE = 'SET_MODULE';
export const SET_SHOW_ADD_MODAL = 'SET_SHOW_ADD_MODAL';
export const RESET_PIECES_JOINTES = 'RESET_PIECES_JOINTES';
